namespace TabAurous.Common {
    export interface Vouchers {
        TransId?: number;
        VoucherNo?: string;
        PartyId?: number;
        POSCustomerId?: number;
    }
}
